<div class="header-container">
  <h1>{{ filterTitle }}</h1>
  <div class="actions">
    <button nz-button nzType="primary" nzDanger [nzSize]="'large'"
            (click)="openModal(mainModal, mainFooter)">
      <span nz-icon nzType="plus"></span>
      Add {{ filterTitleLower }}
    </button>
  </div>
</div>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading" [nzParagraph]="{ rows: 4 }">
  <nz-table
    [nzData]="quickfilters"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzSize]="'middle'"
    [nzLoading]="isCRUD"
  >
    <thead>
    <tr>
      <th nzWidth="200px">Name</th>
      <th>Filter</th>
      <th *ngIf="isStandardFilter" nzWidth="180px">Segments</th>
      <th nzWidth="100px">Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let qf of quickfilters">
      <td><strong>{{ qf.name }}</strong></td>
      <td>
          <span nz-typography nzType="secondary" style="font-size: 12px;">
            {{ getFilterSummary(qf.filter) }}
          </span>
      </td>
      <td *ngIf="isStandardFilter">
        <nz-tag *ngFor="let rule of qf.matching_rules">{{ getMatchingRuleLabel(rule) }}</nz-tag>
        <span *ngIf="!qf.matching_rules?.length" nz-typography nzType="secondary" style="font-size: 12px;">—</span>
      </td>
      <td>
        <div style="display: flex; gap: 8px;">
          <button nz-button nzType="default" nzSize="small"
                  nz-tooltip nzTooltipTitle="Edit"
                  (click)="openModal(mainModal, mainFooter, qf)">
            <span nz-icon nzType="edit"></span>
          </button>
          <button nz-button nzType="default" nzDanger nzSize="small"
                  nz-tooltip nzTooltipTitle="Delete"
                  (click)="deleteQuickfilter(qf.name)">
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
</nz-skeleton>

<ng-template #mainModal>
  <div class="modal-body">

    <nz-form-item>
      <nz-form-label nzRequired>Name</nz-form-label>
      <nz-form-control>
        <input nz-input [(ngModel)]="filterName" placeholder="Quickfilter name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngIf="isStandardFilter">
      <nz-form-label nzRequired>Segments</nz-form-label>
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzPlaceHolder="Select segments (Leading data set)"
          [(ngModel)]="selectedMatchingRules"
        >
          <nz-option
            *ngFor="let opt of matchingRuleOptions"
            [nzValue]="opt.value"
            [nzLabel]="opt.label"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <p class="divider"><span class="text">Conditions</span><span class="line"></span></p>

    <div class="conditions-list">
      <div *ngFor="let condition of workingConditions; let i = index" class="condition-row">
        <div class="condition-fields">

          <nz-select
            class="condition-field-select"
            nzShowSearch
            nzPlaceHolder="Select field"
            [(ngModel)]="condition.field"
            (ngModelChange)="onFieldSelect(condition)"
          >
            <nz-option
              *ngFor="let col of columnDefinition"
              [nzValue]="col.field"
              [nzLabel]="col.headerName"
            ></nz-option>
          </nz-select>

          <ng-container *ngIf="condition.field && condition.filterType">

            <ng-container *ngIf="condition.filterType === 'agSetColumnFilter'">
              <div class="set-filter-wrap">
                <nz-tag
                  *ngFor="let val of condition.values"
                  [nzMode]="'closeable'"
                  (nzOnClose)="removeSetValue(condition, val)"
                >{{ val }}</nz-tag>
                <nz-input-group nzSearch [nzAddOnAfter]="addSetBtn">
                  <input nz-input #setInput placeholder="Enter value" style="width: 160px;" />
                </nz-input-group>
                <ng-template #addSetBtn>
                  <button nz-button nzType="default" [disabled]="!setInput.value"
                          (click)="addSetValue(condition, setInput)">
                    <span nz-icon nzType="plus"></span>
                  </button>
                </ng-template>
              </div>
            </ng-container>

            <ng-container *ngIf="condition.filterType === 'agTextColumnFilter'">
              <nz-select class="condition-option-select" [(ngModel)]="condition.selectedOption">
                <nz-option *ngFor="let opt of condition.filterOptions"
                           [nzValue]="opt" [nzLabel]="getFilterOptionLabel(opt)">
                </nz-option>
              </nz-select>
              <input
                *ngIf="condition.selectedOption !== 'blank' && condition.selectedOption !== 'notBlank'"
                nz-input class="condition-value-input"
                [(ngModel)]="condition.value"
                placeholder="Value"
              />
            </ng-container>

            <ng-container *ngIf="condition.filterType === 'agDateColumnFilter'">
              <nz-select class="condition-option-select" [(ngModel)]="condition.selectedOption">
                <nz-option *ngFor="let opt of condition.filterOptions"
                           [nzValue]="opt" [nzLabel]="getFilterOptionLabel(opt)">
                </nz-option>
              </nz-select>
              <ng-container *ngIf="condition.selectedOption === 'inRange'">
                <nz-date-picker [(ngModel)]="condition.value" nzPlaceHolder="From"></nz-date-picker>
                <nz-date-picker [(ngModel)]="condition.valueTo" nzPlaceHolder="To"></nz-date-picker>
              </ng-container>
              @if (condition.selectedOption === 'inDays') {
                <input nz-input type="number" class="condition-value-input" [(ngModel)]="condition.value" placeholder="Number of days" />
              }
              @if (condition.selectedOption === 'inPastDays') {
                <input nz-input type="number" class="condition-value-input" [(ngModel)]="condition.value" placeholder="Number of days" />
              }
            </ng-container>

            <ng-container *ngIf="condition.filterType === 'agNumberColumnFilter'">
              <nz-select class="condition-option-select" [(ngModel)]="condition.selectedOption">
                <nz-option *ngFor="let opt of condition.filterOptions"
                           [nzValue]="opt" [nzLabel]="getFilterOptionLabel(opt)">
                </nz-option>
              </nz-select>
              <ng-container *ngIf="condition.selectedOption === 'inRange'">
                <input nz-input type="number" class="condition-value-input" [(ngModel)]="condition.value" placeholder="From" />
                <input nz-input type="number" class="condition-value-input" [(ngModel)]="condition.valueTo" placeholder="To" />
              </ng-container>
            </ng-container>

          </ng-container>
        </div>

        <button nz-button nzDanger nzType="text" nzSize="small" (click)="removeCondition(i)">
          <span nz-icon nzType="delete"></span>
        </button>
      </div>
    </div>

    <button nz-button nzType="dashed" (click)="addCondition()" class="add-condition-btn">
      <span nz-icon nzType="plus"></span>
      Add condition
    </button>

  </div>
</ng-template>

<ng-template #mainFooter let-ref="modalRef">
  <button nz-button (click)="closeModal(ref)">Cancel</button>
  <button nz-button nzType="primary" nzDanger
          [nzLoading]="isCRUD"
          [disabled]="isMainSaveDisabled()"
          (click)="saveQuickfilter(ref)">
    Save
  </button>
</ng-template>
